import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Icon,
  Typography,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  IconButton,
  Tooltip,
  Slider,
} from "@material-ui/core";
import { quCreateColor } from "assets/jss/material-dashboard-pro-react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import DoneIcon from "@material-ui/icons/Done";
import SaveIcon from "@material-ui/icons/Save";
import VisibilityIcon from "@material-ui/icons/Visibility";
import UndoIcon from "@material-ui/icons/Undo";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import UnfoldLessIcon from "@material-ui/icons/UnfoldLess";
import TextField from "@material-ui/core/TextField";
import { condenseSlideAPI, splitSlideAPI } from "views/APIs/CourseUtility";

import Button from "components/CustomButtons/Button.js";
import ExitReviewButton from "components/CustomButtons/ExitReviewButton";
import Alert from "views/Components/Alert";
import NotificationContext from "views/Components/Context.js";
import ReviewSlide from "./ReviewSlide";

import { dropzoneStyles } from "views/Styles/dropzoneStyles";

import {
  replaceResourceAPI,
  submitModuleForStructureGeneration,
  getTemplatesAPI,
  validateTemplateAPI,
  storeCustomTemplateAPI,
} from "views/APIs/APIUtility";
import { DropzoneArea } from "material-ui-dropzone";
import { makeStyles } from "@material-ui/core/styles";
import { CloudDownload, GetApp, RotateLeft } from "@material-ui/icons";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...dropzoneStyles,
}));

export default function SlidesContentReview(props) {
  const { showNotification } = useContext(NotificationContext);

  // Existing states
  const [slideHeaders, setSlideHeaders] = useState([]);
  const [slideContents, setSlideContents] = useState([]);
  const [speakerNotes, setSpeakerNotes] = useState([]);
  const [loadingState, setLoadingState] = useState({
    isLoading: false,
    message: "",
  });
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [showTemplateDialog, setShowTemplateDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("style-99");
  const [templateUrl, setTemplateUrl] = useState("");

  // NEW: For the eye-icon preview flow
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const [showEnlargedDialog, setShowEnlargedDialog] = useState(false);
  const [enlargedImage, setEnlargedImage] = useState("");
  const [module, setModule] = useState(props.module);

  // Undo functionality
  const [history, setHistory] = useState([]);

  // Split slide dialog
  const [showSplitDialog, setShowSplitDialog] = useState(false);
  const [numSlides, setNumSlides] = useState(2);
  const [splitFeedback, setSplitFeedback] = useState("");

  // Condense slide dialog
  const [showCondenseDialog, setShowCondenseDialog] = useState(false);
  const [condenseFeedback, setCondenseFeedback] = useState("");

  useEffect(() => {
    const setSlidesandFetchData = async () => {
      setLoadingState({ isLoading: true, message: "Loading Slides..." });
      const card = props.slides[0];
      if (card) {
        const slidesDataLink = card.resource_link;
        const data = await fetchSlidesContent(slidesDataLink);
        const localHeaders = [];
        const localContent = [];
        const localNotes = [];
        data.forEach((slide) => {
          localHeaders.push(slide.slide_header);
          localContent.push(slide.slide_content);
          localNotes.push(slide.speaker_notes);
        });
        setSlideHeaders(localHeaders);
        setSlideContents(localContent);
        setSpeakerNotes(localNotes);
        setIsLoading(false);
        setLoadingState({ isLoading: false, message: "" });
        // Initialize history with the initial state
        setHistory([
          {
            headers: [...localHeaders],
            contents: [...localContent],
            speakerNotes: [...localNotes],
          },
        ]);
      } else {
        console.warn("No slide data found.");
      }
    };
    setSlidesandFetchData();
  }, [props.slides]);

  const fetchSlidesContent = async (fileUrl) => {
    const formData = new FormData();
    formData.append("url", fileUrl);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_FASTAPI_URL}/fetch_quizdata`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      return data;
    } catch (err) {
      console.error("Error fetching file:", err);
    }
  };

  const convertDataToJSON = (data) => {
    const jsonString = JSON.stringify(data);
    const blob = new Blob([jsonString], { type: "application/json" });
    const file = new File([blob], "data.json", { type: "application/json" });
    return file;
  };

  const writeFile = () => {
    const data = [];
    for (let i = 0; i < slideHeaders.length; i++) {
      data.push({
        slide_header: slideHeaders[i],
        slide_content: slideContents[i],
        speaker_notes: speakerNotes[i],
      });
    }
    console.log("Data to be written:", data);
    return convertDataToJSON(data);
  };

  const handleSaveChanges = async () => {
    setLoadingState({ isLoading: true, message: "Saving changes..." });
    const file = writeFile();
    const formData = new FormData();
    formData.append("course_id", props.courseID);
    formData.append("module_id", props.moduleID);
    formData.append("resource_type", "Slide_Content");
    formData.append(
      "resource_description",
      props.slides[0].resource_description
    );
    formData.append("resource_id", props.slides[0].resource_id);
    formData.append("resource_name", props.slides[0].resource_name);
    formData.append("resource_file", file);
    formData.append("course_design_step", 5);

    try {
      await replaceResourceAPI(formData);
      showNotification("Changes saved successfully", "success");
    } catch (error) {
      console.error("Error in handleSaveChanges:", error);
      showNotification("Error saving changes", "danger");
    } finally {
      setLoadingState({ isLoading: false, message: "" });
    }
  };

  const submitForStructureReviewHandler = async () => {
    // await handleSaveChanges();
    setLoadingState({
      isLoading: true,
      message: "Submitting for structure review...",
    });
    const formData = new FormData();
    formData.append("course_id", props.courseID);
    formData.append("module_id", props.moduleID);
    formData.append("template_url", templateUrl);

    try {
      await submitModuleForStructureGeneration(formData);
      setLoadingState({ isLoading: false, message: "" });
      showNotification(
        "Marked as reviewed. You will be notified when the content is ready for the structure review.",
        "success"
      );
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      showNotification("Error submitting module", "danger");
    }
  };

  const verifySubmitAction = () => {
    if (props.moduleStatus != "Content Review") {
      setShowAlert(true);
    } else {
      submitForStructureReviewHandler();
    }
  };

  const verifySubmission = () => {
    handleSaveChanges();
    setShowTemplateDialog(true);
  };

  const handleConfirm = () => {
    setShowAlert(false);
    submitForStructureReviewHandler();
  };

  const handleCancel = () => {
    setShowAlert(false);
  };

  const handleRemoveSlide = () => {
    if (slideHeaders.length === 0) return;

    // Save current state to history before removing
    saveToHistory();

    setSlideHeaders((prev) => prev.filter((_, idx) => idx !== activeSlide));
    setSlideContents((prev) => prev.filter((_, idx) => idx !== activeSlide));
    setSpeakerNotes((prev) => prev.filter((_, idx) => idx !== activeSlide));
    setActiveSlide((prev) => Math.max(0, prev - 1));
  };

  const handleAddSlide = () => {
    // Save current state to history before adding
    saveToHistory();

    setSlideHeaders((prev) => {
      const newHeaders = [...prev];
      newHeaders.splice(activeSlide + 1, 0, "");
      return newHeaders;
    });
    setSlideContents((prev) => {
      const newContents = [...prev];
      newContents.splice(activeSlide + 1, 0, "");
      return newContents;
    });
    setSpeakerNotes((prev) => {
      const newNotes = [...prev];
      newNotes.splice(activeSlide + 1, 0, "");
      return newNotes;
    });
    setActiveSlide((prev) => prev + 1);
  };

  const handleTemplateDialogClose = () => {
    setShowTemplateDialog(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchTemplates = async () => {
    try {
      let data = await getTemplatesAPI();

      // 1) Sort the templates by name, ensuring "style-99" is always at the top.
      data.sort((a, b) => {
        if (a.name === "style-99") return -1;
        if (b.name === "style-99") return 1;
        const numA = parseInt(a.name.split("-")[1], 10);
        const numB = parseInt(b.name.split("-")[1], 10);
        return numA - numB;
      });

      // 2) Sort the .png files in each template's files.pngs array
      data.forEach((template) => {
        template.files.pngs.sort((a, b) => a.localeCompare(b));
      });

      // 3) Use the sorted data
      setTemplates(data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template.name);
    setTemplateUrl(template.files.source);
  };

  const handleCustomTemplateUpload = async (file) => {
    if (file.length === 0) return;
    file = file[0];
    const formData = new FormData();
    formData.append("template_file", file);

    try {
      const isValid = await validateTemplateAPI(formData);
      if (!isValid) {
        showNotification(
          "Invalid template. Please download the source template and try again.",
          "danger"
        );
        return;
      }
      formData.append("course_id", props.courseID);
      formData.append("module_id", props.moduleID);
      const response = await storeCustomTemplateAPI(formData);
      setTemplateUrl(response.url);
      showNotification("Template uploaded successfully", "success");
    } catch (error) {
      console.error("Error uploading template:", error);
      showNotification("Error uploading template", "danger");
    }
  };

  // NEW: Eye icon => open the “preview template” dialog
  const handleOpenPreviewDialog = (e, template_name) => {
    e.stopPropagation();
    setSelectedTemplate(template_name);
    setTemplateUrl(
      templates.find((template) => template.name === template_name).files.source
    );
    setShowPreviewDialog(true);
  };

  // Clicking on the 4 preview slides => open the “enlarged” dialog
  const handleOpenEnlarged = (imgSrc) => {
    setEnlargedImage(imgSrc);
    setShowEnlargedDialog(true);
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleNextSlide = async () => {
    // await handleSaveChanges();
    setActiveSlide(activeSlide + 1);
  };

  const handlePreviousSlide = async () => {
    // await handleSaveChanges();
    setActiveSlide(activeSlide - 1);
  };

  const handlePreviousTab = async () => {
    // await handleSaveChanges();
    props.setActiveTab("Overview");
  };

  // Save current state to history before making changes
  const saveToHistory = () => {
    setHistory((prev) => [
      ...prev,
      {
        headers: [...slideHeaders],
        contents: [...slideContents],
        speakerNotes: [...speakerNotes],
      },
    ]);
  };

  // Undo the last change
  const handleUndo = () => {
    if (history.length <= 1) {
      showNotification("No more changes to undo", "info");
      return;
    }
    const newHistory = [...history];
    newHistory.pop(); // Remove current state
    const previousState = newHistory[newHistory.length - 1];
    setSlideHeaders([...previousState.headers]);
    setSlideContents([...previousState.contents]);
    setSpeakerNotes([...previousState.speakerNotes]);
    setHistory(newHistory);
    showNotification("Changes undone", "success");
  };

  // Condense current slide
  const handleCondenseSlide = async () => {
    if (
      !slideHeaders[activeSlide] &&
      !slideContents[activeSlide] &&
      !speakerNotes[activeSlide]
    ) {
      showNotification("Current slide is empty", "warning");
      return;
    }

    setLoadingState({ isLoading: true, message: "Condensing slide..." });

    const formData = new FormData();
    formData.append("slide_header", slideHeaders[activeSlide] || "");
    formData.append("slide_content", slideContents[activeSlide] || "");
    formData.append("speaker_notes", speakerNotes[activeSlide] || "");
    formData.append("additional_instructions", condenseFeedback || "");

    try {
      const response = await condenseSlideAPI(formData);

      console.log("Condense response:", response);

      // Save current state to history
      saveToHistory();

      // Update with condensed content
      setSlideHeaders(
        slideHeaders.map((item, index) =>
          index === activeSlide ? response.slide_header || item : item
        )
      );
      setSlideContents(
        slideContents.map((item, index) =>
          index === activeSlide ? response.slide_content || item : item
        )
      );
      setSpeakerNotes(
        speakerNotes.map((item, index) =>
          index === activeSlide ? response.speaker_notes || item : item
        )
      );

      showNotification("Slide condensed successfully", "success");
      setShowCondenseDialog(false);
      setCondenseFeedback("");
    } catch (error) {
      console.error("Error condensing slide:", error);
      showNotification("Error condensing slide", "danger");
    } finally {
      setLoadingState({ isLoading: false, message: "" });
    }
  };

  // Split current slide
  const handleSplitSlide = async () => {
    if (
      !slideHeaders[activeSlide] &&
      !slideContents[activeSlide] &&
      !speakerNotes[activeSlide]
    ) {
      showNotification("Current slide is empty", "warning");
      return;
    }

    setLoadingState({
      isLoading: true,
      message: `Splitting slide into ${numSlides} slides...`,
    });

    const formData = new FormData();
    formData.append("slide_header", slideHeaders[activeSlide] || "");
    formData.append("slide_content", slideContents[activeSlide] || "");
    formData.append("speaker_notes", speakerNotes[activeSlide] || "");
    formData.append("num_slides", numSlides.toString());
    formData.append("additional_instructions", splitFeedback || "");

    try {
      const response = await splitSlideAPI(formData);

      // Save current state to history
      saveToHistory();

      // Remove current slide and insert new split slides
      const newHeaders = [...slideHeaders];
      const newContents = [...slideContents];
      const newNotes = [...speakerNotes];

      // Remove the current slide
      newHeaders.splice(activeSlide, 1);
      newContents.splice(activeSlide, 1);
      newNotes.splice(activeSlide, 1);

      // Insert the split slides
      response.slides.forEach((slide, index) => {
        newHeaders.splice(activeSlide + index, 0, slide.slide_header || "");
        newContents.splice(activeSlide + index, 0, slide.slide_content || "");
        newNotes.splice(activeSlide + index, 0, slide.speaker_notes || "");
      });

      setSlideHeaders(newHeaders);
      setSlideContents(newContents);
      setSpeakerNotes(newNotes);

      showNotification(
        `Slide split into ${response.slides.length} slides successfully`,
        "success"
      );
      setShowSplitDialog(false);
    } catch (error) {
      console.error("Error splitting slide:", error);
      showNotification("Error splitting slide", "danger");
    } finally {
      setLoadingState({ isLoading: false, message: "" });
    }
  };

  if (loadingState.isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress
          color="quCreateColor"
          className={classes.loaderClass}
        />
        <Typography
          variant="h6"
          style={{ marginLeft: 16, textTransform: "none" }}
        >
          {loadingState.message}
        </Typography>
      </Box>
    );
  }

  return (
    <div>
      {showAlert && (
        <Alert
          title="Are you sure?"
          warning={true}
          showCancel={true}
          cancelBtnText="No"
          confirmBtnText="Yes"
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        >
          You already have a submission for this module. If you wish to make
          another submission, your module will be submitted for structure
          review.
        </Alert>
      )}

      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={10} sm={10}>
          <Typography variant="h5">Slides Content Review</Typography>
          <Typography variant="body1">
            Review the content for the slides including the speaker notes and
            the slide content.
          </Typography>
        </Grid>
        <Grid
          item
          xs={2}
          sm={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingRight: "10px",
            gap: "8px",
          }}
        >
          <Tooltip title="Undo Changes">
            <span>
              <IconButton
                onClick={handleUndo}
                disabled={history.length <= 1}
                style={{
                  color: history.length <= 1 ? "gray" : "#20677b",
                }}
              >
                <UndoIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Condense Slide">
            <IconButton
              onClick={() => setShowCondenseDialog(true)}
              style={{ color: "#20677b" }}
              disabled={
                !slideContents[activeSlide] ||
                slideContents[activeSlide].trim() === ""
              }
            >
              <UnfoldLessIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Split Slide">
            <IconButton
              onClick={() => setShowSplitDialog(true)}
              style={{ color: "#20677b" }}
            >
              <CallSplitIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Add Slide After">
            <IconButton onClick={handleAddSlide} style={{ color: "#20677b" }}>
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remove Slide">
            <span>
              <IconButton
                onClick={handleRemoveSlide}
                disabled={slideHeaders.length === 1}
                color="secondary"
              >
                <RemoveIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Grid>
      </Grid>

      <Grid container spacing={3} style={{ marginTop: "20px" }}>
        <Grid item xs={12} sm={12}>
          <ReviewSlide
            slideHeader={slideHeaders[activeSlide]}
            slideContent={slideContents[activeSlide]}
            speakerNotes={speakerNotes[activeSlide]}
            setSlideHeader={(value) => {
              setSlideHeaders(
                slideHeaders.map((item, index) =>
                  index === activeSlide ? value : item
                )
              );
            }}
            setSlideContent={(value) => {
              setSlideContents(
                slideContents.map((item, index) =>
                  index === activeSlide ? value : item
                )
              );
            }}
            setSpeakerNotes={(value) => {
              setSpeakerNotes(
                speakerNotes.map((item, index) =>
                  index === activeSlide ? value : item
                )
              );
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12} justify="center">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Button
                style={{ float: "right" }}
                color="quSandBoxColor"
                disabled={activeSlide === 0}
                onClick={handlePreviousSlide}
              >
                <Icon>arrow_back</Icon>
                &nbsp; Previous Slide
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography
                variant="body1"
                style={{ textAlign: "center", marginTop: "10px" }}
              >
                Slide {activeSlide + 1} of {slideHeaders.length}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Button
                style={{ float: "left" }}
                color="quSandBoxColor"
                disabled={activeSlide === slideHeaders.length - 1}
                onClick={handleNextSlide}
              >
                Next Slide&nbsp;
                <Icon>arrow_forward</Icon>
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} style={{ textAlign: "left" }}>
              <ExitReviewButton courseID={props.courseID} />
            </Grid>
            <Grid item xs={12} sm={4} style={{ textAlign: "center" }} />
            <Grid item xs={12} sm={4} style={{ textAlign: "right" }}>
              <Button
                color="info"
                onClick={verifySubmission}
                style={{ float: "right" }}
                endIcon={<DoneIcon />}
              >
                Mark as Reviewed
              </Button>
              &nbsp;
              <Button
                color="success"
                onClick={handleSaveChanges}
                style={{ float: "right" }}
                startIcon={<SaveIcon />}
              >
                Save Changes
              </Button>
              &nbsp;
              <Button
                color="quSandBoxColor"
                onClick={handlePreviousTab}
                style={{ float: "right" }}
                startIcon={<NavigateBeforeIcon />}
              >
                Previous
              </Button>
              &nbsp;
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/** Existing Template-Selection Dialog */}
      <Dialog
        open={showTemplateDialog}
        onClose={handleTemplateDialogClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Choose a Template</DialogTitle>
        <DialogContent>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { backgroundColor: quCreateColor } }}
          >
            <Tab label="Choose Template" />
            <Tab label="Upload Custom Template" />
          </Tabs>
          {tabValue === 0 && (
            <Grid container spacing={2} style={{ marginTop: "20px" }}>
              {templates.map((template) => (
                <Grid item xs={4} key={template.name}>
                  <Card
                    onClick={() => handleTemplateSelect(template)}
                    style={{
                      border:
                        selectedTemplate === template.name
                          ? "2px solid blue"
                          : "none",
                    }}
                  >
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        // Fit to content
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "auto",
                          maxHeight: 200,
                        }}
                        image={template.files.pngs[0]}
                        title={template.name}
                      />
                      <CardContent>
                        {/* Name + Eye Icon */}
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Typography
                            variant="h6"
                            style={{ textTransform: "none" }}
                          >
                            {template.name}
                          </Typography>
                          <IconButton
                            onClick={(e) =>
                              handleOpenPreviewDialog(e, template.name)
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
          {tabValue === 1 && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              style={{ marginTop: "20px" }}
            >
              <Typography variant="body1">
                Download the source file below and edit your design to create
                your own custom template.
              </Typography>
              <Grid
                container
                spacing={2}
                justify="center"
                display="flex"
                justifyContent="center"
              >
                <Grid item xs={4} fullWidth>
                  <Button
                    color="quCreateColor"
                    href={
                      templates.find((template) => template.name === "style-0")
                        ?.files.source
                    }
                    style={{ marginTop: "10px", width: "100%" }}
                    startIcon={<CloudDownload />}
                  >
                    Download Source Template
                  </Button>
                </Grid>
                {module.template_link && (
                  <Grid item xs={4} fullWidth>
                    <Button
                      color="quCreateColor"
                      href={module.template_link}
                      style={{ marginTop: "10px", width: "100%" }}
                      startIcon={<GetApp />}
                    >
                      Download Previous Template
                    </Button>
                  </Grid>
                )}
                {module.template_link && (
                  <Grid item xs={4} fullWidth>
                    <Button
                      color="quCreateColor"
                      onClick={() => {
                        setTemplateUrl(module.template_link);
                        handleTemplateDialogClose();
                        verifySubmitAction();
                        showNotification(
                          "Using Previously Uploaded Template",
                          "success"
                        );
                      }}
                      style={{ marginTop: "10px", width: "100%" }}
                      startIcon={<RotateLeft />}
                    >
                      Use Previous template
                    </Button>
                  </Grid>
                )}
              </Grid>

              <DropzoneArea
                acceptedFiles={[".pptx"]}
                filesLimit={1}
                useChipsForPreview
                showPreviewsInDropzone={false}
                dropzoneClass={classes.dropzone}
                maxFileSize={50000000}
                showPreviews={true}
                dropzoneText="Drag and drop or click to upload the edited .pptx file here."
                onChange={handleCustomTemplateUpload}
                style={{ marginTop: "20px" }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTemplateDialogClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowTemplateDialog(false);
              verifySubmitAction();
            }}
            color="quCreateColor"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/** NEW: Dialog for “Template Preview” (eye icon) */}
      <Dialog
        open={showPreviewDialog}
        onClose={() => setShowPreviewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Template Preview</DialogTitle>
        <DialogContent>
          {/* Show four preview cards */}
          <Grid container spacing={2}>
            {templates
              .find((template) => template.name === selectedTemplate)
              ?.files.pngs.map((imgSrc, index) => (
                <Grid item xs={3} key={imgSrc}>
                  <Card>
                    <CardActionArea onClick={() => handleOpenEnlarged(imgSrc)}>
                      <CardMedia
                        component="img"
                        // Fit to content
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "auto",
                          maxHeight: 200,
                        }}
                        image={imgSrc}
                        title={selectedTemplate}
                      />
                      <CardContent>
                        <Typography variant="body1">
                          {
                            [
                              "Title Slide",
                              "Content Slide",
                              "Content and Image Slide",
                            ][index]
                          }
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowPreviewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/** NEW: Dialog for Enlarged Image */}
      <Dialog
        open={showEnlargedDialog}
        onClose={() => setShowEnlargedDialog(false)}
        maxWidth="lg"
      >
        <DialogContent>
          <img
            src={enlargedImage}
            alt="Enlarged"
            style={{ maxWidth: "100%", height: "100%" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowEnlargedDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/** Condense Slide Dialog */}
      <Dialog
        open={showCondenseDialog}
        onClose={() => {
          setShowCondenseDialog(false);
          setCondenseFeedback("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Condense Slide</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: "20px" }}>
            Condense the current slide to make it more concise while retaining
            the key information.
          </Typography>
          <Box style={{ marginTop: "20px" }}>
            <TextField
              label="Guidance (Optional)"
              placeholder={`Examples:
• Focus on key takeaways only
• Remove redundant information
• Keep only the most important bullet points
• Simplify technical jargon`}
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={condenseFeedback}
              onChange={(e) => setCondenseFeedback(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowCondenseDialog(false);
              setCondenseFeedback("");
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button onClick={handleCondenseSlide} color="quCreateColor">
            Condense Slide
          </Button>
        </DialogActions>
      </Dialog>

      {/** Split Slide Dialog */}
      <Dialog
        open={showSplitDialog}
        onClose={() => {
          setShowSplitDialog(false);
          setSplitFeedback("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Split Slide</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: "20px" }}>
            Split the current slide into multiple slides. Select the number of
            slides you want to create:
          </Typography>
          <Box sx={{ px: 2 }}>
            <Typography gutterBottom>Number of Slides: {numSlides}</Typography>
            <Slider
              value={numSlides}
              onChange={(e, newValue) => setNumSlides(newValue)}
              min={2}
              max={5}
              step={1}
              marks
              valueLabelDisplay="auto"
              style={{ color: "#20677b" }}
            />
          </Box>
          <Box style={{ marginTop: "20px" }}>
            <TextField
              label="Guidance (Optional)"
              placeholder={`Examples:
• Split by bullet points: Each bullet point should be on a separate slide.
• Split by sections: Divide the content into three main sections.
• Split by topic: Have topic A, topic B, and topic C each on their own slide.`}
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={splitFeedback}
              onChange={(e) => setSplitFeedback(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowSplitDialog(false);
              setSplitFeedback("");
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button onClick={handleSplitSlide} color="quCreateColor">
            Split Slide
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
